import { render } from "./StockRangeSelector.vue?vue&type=template&id=2308eb11&scoped=true&ts=true"
import script from "./StockRangeSelector.vue?vue&type=script&lang=ts"
export * from "./StockRangeSelector.vue?vue&type=script&lang=ts"

import "./StockRangeSelector.vue?vue&type=style&index=0&id=2308eb11&scoped=true&lang=css"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2308eb11"]])

export default __exports__